import { watch } from "vue";
import { onClickOutside } from "@vueuse/core";

/**
 * Closes the open popup on a click outside the menu. The bottom sheet handles its own.
 *
 * @param {object} options
 * @param {import("vue").Ref<boolean>} options.isActive - the menu's open state.
 * @param {import("vue").Ref<boolean>} options.showBottomSheet - whether the menu renders as a bottom sheet.
 * @param {import("vue").Ref<boolean>} options.closeOnOutsideClick - whether an outside click closes the menu.
 * @param {import("vue").Ref<HTMLElement | null>} options.container - the menu's root element.
 * @param {() => void} options.markClosedByOutsideClick - records that the close came from an outside click.
 */
export function useMenuOutsideClick({
  isActive,
  showBottomSheet,
  closeOnOutsideClick,
  container,
  markClosedByOutsideClick,
}) {
  let stopClickOutside;

  function closeFromOutsideClick() {
    markClosedByOutsideClick();
    isActive.value = false;
  }

  function syncOutsideClick([open, sheet]) {
    stopClickOutside?.();
    stopClickOutside = undefined;

    if (open && !sheet && closeOnOutsideClick.value) {
      stopClickOutside = onClickOutside(container, closeFromOutsideClick);
    }
  }

  watch([isActive, showBottomSheet], syncOutsideClick, { immediate: true });
}
